// components/account-handling/modals/GenericModal.tsx
import React from 'react';

type GenericModalProps = {
    title: string;
    children: React.ReactNode;
};

export default function GenericModal({ title, children }: GenericModalProps) {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded shadow-lg w-1/3">
                <h2 className="text-lg font-bold mb-4">{title}</h2>
                {children}
            </div>
        </div>
    );
}
